import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ClubAdminRegistrationComponent } from './onboarding/components/club-admin-registration/club-admin-registration.component';
import { AdditionalClubDetailsComponent } from './onboarding/components/additional-club-details/additional-club-details.component';
import { WelcomePageComponent } from './onboarding/components/welcome-page/welcome-page.component';
import { ReviewAndSubmitComponent } from './onboarding/components/review-and-submit/review-and-submit.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'onboarding',
    component: OnboardingComponent,
    children: [
      { path: 'create-account', component: ClubAdminRegistrationComponent },
      { path: 'club-details', component: AdditionalClubDetailsComponent },
      { path: 'review-submit', component: ReviewAndSubmitComponent },
      { path: 'welcome', component: WelcomePageComponent },
      { path: '', redirectTo: 'create-account', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }
